/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sreality_Attr_Auction_AdvertisementInputs */

const cs_sreality_attr_auction_advertisement = /** @type {(inputs: Sreality_Attr_Auction_AdvertisementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inzerát dražby (PDF)`)
};

const en_sreality_attr_auction_advertisement = /** @type {(inputs: Sreality_Attr_Auction_AdvertisementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auction advertisement (PDF)`)
};

/**
* | output |
* | --- |
* | "Auction advertisement (PDF)" |
*
* @param {Sreality_Attr_Auction_AdvertisementInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const sreality_attr_auction_advertisement = /** @type {((inputs?: Sreality_Attr_Auction_AdvertisementInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sreality_Attr_Auction_AdvertisementInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sreality_attr_auction_advertisement(inputs)
	return cs_sreality_attr_auction_advertisement(inputs)
});